import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./pop.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactFormPage = () => {
  const [formData, setFormData] = useState({ name: "", phoneNumber: "" });
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      await addDoc(collection(db, "popup_contacts"), formData);
      toast.success("Message Submitted Successfully!");
      setFormData({ name: "", phoneNumber: "" });
    } catch (error) {
      console.error("Error submitting contact: ", error);
      toast.error("Something went wrong. Please try again.");
    }
    setUploading(false);
  };

  return (
    <div className="form-container1">
      <h2 className="heading-contact">Contact Us</h2>
      <form onSubmit={handleSubmit} className="contact-form1">
        <label className="label">Name:</label>
        <input
          type="text"
          name="name"
          placeholder="Enter your Full name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label className="label">Mobile Number:</label>
        <input
          type="tel"
          name="phoneNumber"
          placeholder="Enter your Mobile number"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
        />

        <button type="submit" className="submit-button" disabled={uploading}>
          {uploading ? "Submitting..." : "Submit"}
        </button>
      </form>

      {/* Toast Notification Container */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default ContactFormPage;
